const NavbarMenuItems = [
  {
    name: 'Dashboard',
    icon: 'dashboard',
    url: '/overview/',
  },
  // {
  //   name: 'Management',
  //   subHeading: true,
  // },
  {
    name: 'Coupons',
    icon: 'credit_card',
    url: '/coupons/',
    roles: ['View coupons']
  },
  {
    name: 'Libraries',
    icon: 'apartment',
    group: true,
    roles: [],
    items: [
      {
        name: 'In-Progress',
        icon: 'analytics',
        url: '/libraries/in-progress/',
        roles: ['View in-progress libraries']
      },
      {
        name: 'Pending Approval',
        icon: 'fact_check',
        url: '/libraries/approvals/',
        roles: ['View libraries pending approval']
      },
      {
        name: 'Approved Libraries',
        icon: 'fact_check',
        url: '/libraries/approved/',
        roles: ['View approved libraries']
      },
      {
        name: 'Bookings',
        icon: 'event',
        group: true,
        items: [
          {
            name: 'All Bookings',
            icon: 'date_range',
            url: '/libraries/bookings/all/',
            roles: ['View library bookings']
          },
          {
            name: 'Pending Refund',
            icon: 'payment',
            url: '/libraries/bookings/pending-refund/',
            roles: ['Approve library booking refund']
          },
          {
            name: 'Bulk Upload',
            icon: 'cloud_upload',
            url: '/libraries/bookings/bulk-upload/',
            roles: ['Upload library bookings']
          },
        ]
      },
      {
        name: 'Library Types',
        icon: 'corporate_fare',
        url: '/libraries/type/',
        roles: ['View library type']
      },
      {
        name: 'Amenities',
        icon: 'attractions',
        url: '/libraries/amenities/',
        roles: ['View library amenities']
      },
    ]
  },
  {
    name: 'Incentives',
    icon: 'wallet',
    url: '/incentives/',
    roles: ['View incentives']
  },
  {
    name: 'Payouts',
    icon: 'account_balance',
    url: '/payouts/',
    roles: ['View payouts']
  },
  {
    name: 'Students',
    icon: 'people',
    url: '/students/',
    roles: ['View students'],
  },
  {
    name: 'Vendors',
    icon: 'supervised_user_circle',
    url: '/vendors/',
    roles: ['View vendors'],
  },
  {
    name: 'Complaints',
    icon: 'warning_amber',
    roles: ['View complaints'],
    url: '/complaints/'
  },
  {
    name: 'Subscriptions',
    icon: 'card_membership',
    roles: ['View subscriptions'],
    url: '/subscriptions/'
  },
  {
    name: 'Feedback',
    icon: 'feedback',
    group: true, 
    // roles: ['admin', 'manager', 'employee'],
    items: [
      {
        name: 'Student',
        icon: 'people',
        url: '/feedback/student/',
        roles: ['View student feedback'],
      },
      {
        name: 'Vendor',
        icon: 'supervised_user_circle',
        url: '/feedback/vendor/',
        roles: ['View vendor feedback'],
      },
      {
        name: 'Reviews',
        icon: 'reviews',
        url: '/feedback/library-reviews/',
        roles: ['View reviews'],
      },
    ]
  },
  {
    name: 'Settings',
    icon: 'settings',
    group: true,
    // roles: ['admin', 'manager', 'employee'],
    items: [
      {
        name: 'Banner Images',
        icon: 'photo_library',
        url: '/settings/banner-images/',
        roles: ['Modify banner images']
      },
      {
        name: 'Configurations',
        icon: 'tune',
        url: '/settings/configurations/',
        roles: ['View configurations']
      },
    ]
  },
  {
    name: 'Roles & Perimssions',
    icon: 'engineering',
    group: true,
    // roles: ['admin', 'manager', 'employee'],
    items: [
      {
        name: 'Roles',
        icon: 'supervised_user_circle',
        url: '/roles/',
        roles:['View roles']
      },
      {
        name: 'Permissions',
        icon: 'admin_panel_settings',
        url: '/permissions/',
        roles:['View permissions']
      },
    ]
  },
  {
    name: 'Admin Users',
    icon: 'manage_accounts',
    roles: ['View admin users'],
    url: '/admin/users'
  },
  {
    name: 'Activity Log',
    icon: 'analytics',
    url: '/activity-log/',
    roles: []
  },
];

export default NavbarMenuItems;
